module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iRWJlbmVfMSIgZGF0YS1uYW1lPSJFYmVuZSAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNTAgMjUwIj48ZGVmcz48c3R5bGU+LmNscy0xe3N0cm9rZTojMDAwO3N0cm9rZS1taXRlcmxpbWl0OjEwO3N0cm9rZS13aWR0aDo4cHg7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5aZWljaGVuZmzDpGNoZSAxNTwvdGl0bGU+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNODAuNjcsMTIwLDE1MiwxOTEuMzNhNC4yOCw0LjI4LDAsMCwwLDYuMDYtNi4wNUw4OS43NiwxMTcsMTU4LDQ4LjczYTQuMjYsNC4yNiwwLDAsMCwwLTYsNC4zMSw0LjMxLDAsMCwwLTMtMS4yNyw0LjE1LDQuMTUsMCwwLDAtMywxLjI3TDgwLjcsMTE0YTQuMjUsNC4yNSwwLDAsMCwwLDZabTAsMCIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./static/svg/arrow-left.svg
// module id = U64w
// module chunks = 1